"use strict";

exports.__esModule = true;
exports.component = void 0;

var _propTypes = require("prop-types");

var component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string, (0, _propTypes.shape)({
  render: _propTypes.func.isRequired
})]);
exports.component = component;